export const TOOLKIT_LIST = [
  {
    name: '\u5b89\u5168\u5de5\u5177',
    tools: [
      {
        name: 'MD5 \u54c8\u5e0c\u78b0\u649e',
        url: '/tools/md5fastcollision',
      },
      {
        name: 'ZIP \u5bc6\u7801\u7834\u89e3',
        url: '/tools/zipcrack',
      },
      {
        name: 'XSS \u5411\u91cf\u751f\u6210',
        url: '/tools/xssvector',
      },
      {
        name: 'WebShell \u68c0\u6d4b',
        url: '/webShell',
      },
    ],
  },
  {
    name: '\u683c\u5f0f\u8f6c\u6362',
    tools: [
      {
        name: 'LESS CSS \u4e92\u8f6c',
        url: '/tools/less2css',
      },
      {
        name: 'markdown html \u4e92\u8f6c',
        url: '/tools/md2html',
      },
      {
        name: 'JSON XML \u4e92\u8f6c',
        url: '/tools/json2xml',
      },
      {
        name: 'JSON \u8f6c yaml',
        url: '/tools/json2yaml',
      },
      {
        name: 'JSON \u8f6c GO',
        url: '/tools/json2go',
      },
      {
        name: 'JSON \u8f6c CSV/EXCEL',
        url: '/tools/jsontocsv',
      },
      {
        name: 'JSON JavaScript \u4e92\u8f6c',
        url: '/tools/json2js',
      },
    ],
  },
  {
    name: '\u6280\u672f\u901f\u67e5\u8868',
    tools: [
      {
        name: 'Git \u547d\u4ee4\u901f\u67e5',
        url: '/tools/git',
      },
      {
        name: 'ASCII \u7801\u8868',
        url: '/tools/ascii',
      },
    ],
  },
  {
    name: '\u56fe\u7247\u5904\u7406',
    tools: [
      {
        name: '\u56fe\u7247\u8f6c Base64',
        url: '/tools/img2base64',
      },
      {
        name: 'OCR \u56fe\u7247\u6587\u5b57\u8bc6\u522b',
        url: '/tools/ocr',
      },
      {
        name: '\u56fe\u7247\u538b\u7f29',
        url: '/tools/img_sharp',
      },
      {
        name: '\u56fe\u7247\u6dfb\u52a0\u6c34\u5370',
        url: '/tools/watermark',
      },
      {
        name: '\u56fe\u7247\u683c\u5f0f\u8f6c\u6362',
        url: '/tools/img_conversion',
      },
    ],
  },
  {
    name: '\u54c8\u5e0c\u8ba1\u7b97',
    tools: [
      {
        name: 'SHA-512/256 \u8ba1\u7b97',
        url: '/toolkit/cyberChef/Hash-SHA-512.256',
      },
      {
        name: 'SHA-512/224 \u8ba1\u7b97',
        url: '/toolkit/cyberChef/Hash-SHA-512.224',
      },
      {
        name: 'SHA-512 \u8ba1\u7b97',
        url: '/toolkit/cyberChef/Hash-SHA-512',
      },
      {
        name: 'SHA-384 \u8ba1\u7b97',
        url: '/toolkit/cyberChef/Hash-SHA-384',
      },
      {
        name: 'SHA-256 \u8ba1\u7b97',
        url: '/toolkit/cyberChef/Hash-SHA-256',
      },
      {
        name: 'SHA-224 \u8ba1\u7b97',
        url: '/toolkit/cyberChef/Hash-SHA-224',
      },
      {
        name: 'MD6 \u8ba1\u7b97',
        url: '/toolkit/cyberChef/Hash-MD6',
      },
      {
        name: 'MD4 \u8ba1\u7b97',
        url: '/toolkit/cyberChef/Hash-MD4',
      },
      {
        name: 'MD2 \u8ba1\u7b97',
        url: '/toolkit/cyberChef/Hash-MD2',
      },
      {
        name: 'MD5 \u8ba1\u7b97',
        url: '/toolkit/cyberChef/Hash-MD5',
      },
    ],
  },
  {
    name: '\u52a0\u5bc6\u89e3\u5bc6',
    tools: [
      {
        name: '\u57f9\u6839\u5bc6\u7801\u89e3\u5bc6',
        url: '/toolkit/cyberChef/BaconDecode',
      },
      {
        name: '\u57f9\u6839\u5bc6\u7801\u52a0\u5bc6',
        url: '/toolkit/cyberChef/BaconEncode',
      },
      {
        name: 'RSA \u89e3\u5bc6',
        url: '/toolkit/cyberChef/RSADecrypt',
      },
      {
        name: 'RSA \u52a0\u5bc6',
        url: '/toolkit/cyberChef/RSAEncrypt',
      },
      {
        name: 'SM4 \u89e3\u5bc6',
        url: '/toolkit/cyberChef/SM4Decrypt',
      },
      {
        name: 'SM4 \u52a0\u5bc6',
        url: '/toolkit/cyberChef/SM4Encrypt',
      },
      {
        name: '3DES \u89e3\u5bc6',
        url: '/toolkit/cyberChef/3DESDecrypt',
      },
      {
        name: '3DES \u52a0\u5bc6',
        url: '/toolkit/cyberChef/3DESEncrypt',
      },
      {
        name: 'DES \u89e3\u5bc6',
        url: '/toolkit/cyberChef/DESDecrypt',
      },
      {
        name: 'DES \u52a0\u5bc6',
        url: '/toolkit/cyberChef/DESEncrypt',
      },
      {
        name: 'AES \u89e3\u5bc6',
        url: '/toolkit/cyberChef/AESDecrypt',
      },
      {
        name: 'AES \u52a0\u5bc6',
        url: '/toolkit/cyberChef/AESEncrypt',
      },
    ],
  },
  {
    name: '\u7f16\u7801\u8f6c\u6362',
    tools: [
      {
        name: 'Unicode \u89e3\u7801',
        url: '/toolkit/cyberChef/UnicodeDecode',
      },
      {
        name: 'Unicode \u7f16\u7801',
        url: '/toolkit/cyberChef/UnicodeEncode',
      },
      {
        name: 'HTML \u89e3\u7801',
        url: '/toolkit/cyberChef/HTMLDecode',
      },
      {
        name: 'HTML \u7f16\u7801',
        url: '/toolkit/cyberChef/HTMLEncode',
      },
      {
        name: '\u6469\u65af\u5bc6\u7801\u89e3\u7801',
        url: '/toolkit/cyberChef/MorseDecode',
      },
      {
        name: '\u6469\u65af\u5bc6\u7801\u7f16\u7801',
        url: '/toolkit/cyberChef/MorseEncode',
      },
      {
        name: 'URL \u89e3\u7801',
        url: '/toolkit/cyberChef/URLDecoder',
      },
      {
        name: 'URL \u7f16\u7801',
        url: '/toolkit/cyberChef/URLEncoder',
      },
      {
        name: 'Hex \u89e3\u7801',
        url: '/toolkit/cyberChef/HexDecoder',
      },
      {
        name: 'Hex \u7f16\u7801',
        url: '/toolkit/cyberChef/HexEncoder',
      },
      {
        name: 'Base64 \u89e3\u7801',
        url: '/toolkit/cyberChef/Base64Decoder',
      },
      {
        name: 'Base64 \u7f16\u7801',
        url: '/toolkit/cyberChef/Base64Encoder',
      },
    ],
  },
  {
    name: '\u4ee3\u7801\u683c\u5f0f\u5316',
    tools: [
      {
        name: 'SQL \u4ee3\u7801\u683c\u5f0f\u5316',
        url: '/toolkit/format/sql',
      },
      {
        name: 'Java \u4ee3\u7801\u683c\u5f0f\u5316',
        url: '/toolkit/format/java',
      },
      {
        name: 'CSS \u4ee3\u7801\u683c\u5f0f\u5316',
        url: '/toolkit/format/css',
      },
      {
        name: 'JavaScript \u4ee3\u7801\u683c\u5f0f\u5316',
        url: '/toolkit/format/javascript',
      },
      {
        name: 'JSON \u4ee3\u7801\u683c\u5f0f\u5316',
        url: '/toolkit/format/json',
      },
      {
        name: 'YAML \u4ee3\u7801\u683c\u5f0f\u5316',
        url: '/toolkit/format/yaml',
      },
      {
        name: 'XML \u4ee3\u7801\u683c\u5f0f\u5316',
        url: '/toolkit/format/xml',
      },
      {
        name: 'HTML \u4ee3\u7801\u683c\u5f0f\u5316',
        url: '/toolkit/format/html',
      },
    ],
  },
  {
    name: '\u6587\u5b57\u5904\u7406',
    tools: [
      {
        name: '\u79fb\u9664\u7a7a\u767d\u5b57\u7b26',
        url: '/toolkit/cyberChef/RemoveWhitespace',
      },
      {
        name: '\u6587\u5b57\u8f6c\u9a7c\u5cf0/\u4e0b\u5212\u7ebf\u683c\u5f0f',
        url: '/tools/camelcase',
      },
      {
        name: '\u4e2d\u82f1\u6587\u52a0\u7a7a\u683c',
        url: '/tools/cn_space_en',
      },
      {
        name: '\u751f\u6210\u4e71\u5e8f\u6587\u5b57',
        url: '/tools/shuffle_text_generator',
      },
      {
        name: '\u6587\u5b57\u6dfb\u52a0\u884c\u53f7',
        url: '/tools/line_number',
      },
      {
        name: '\u751f\u6210 Figlet \u7ec8\u7aef\u827a\u672f\u5b57',
        url: '/tools/figlet',
      },
      {
        name: '\u751f\u6210 Leet \u9ed1\u5ba2\u6587\u5b57',
        url: '/tools/leet_convert',
      },
      {
        name: '\u6587\u672c\u5dee\u5f02\u5bf9\u6bd4',
        url: '/tools/diff',
      },
      {
        name: '\u5927\u5c0f\u5199\u8f6c\u6362',
        url: '/tools/case_convert',
      },
      {
        name: '\u5b57\u6570\u7edf\u8ba1',
        url: '/tools/word_count',
      },
    ],
  },
  {
    name: '\u5176\u4ed6',
    tools: [
      {
        name: '\u624b\u7ed8\u767d\u677f',
        url: '/tools/excalidraw',
      },
      {
        name: '\u989c\u8272\u683c\u5f0f\u8f6c\u6362',
        url: '/tools/color_convert',
      },
      {
        name: '\u968f\u673a IP \u751f\u6210\u5668',
        url: '/tools/random_ip',
      },
      {
        name: '\u968f\u673a\u6570/\u5bc6\u7801\u751f\u6210\u5668',
        url: '/tools/random',
      },
      {
        name: '\u8fdb\u5236\u8f6c\u6362',
        url: '/tools/radix_convert',
      },
      {
        name: 'Unix \u65f6\u95f4\u6233\u8f6c\u6362',
        url: '/tools/unix',
      },
      {
        name: '\u4ee3\u7801\u622a\u56fe',
        url: '/toolkit/codeshot',
      },
    ],
  },
]

export const ALL_TOOLKIT_LIST = [
  {
    name: '\u54c8\u5e0c\u8ba1\u7b97',
    tools: [
      {
        name: 'SHA-512/256 \u8ba1\u7b97',
        url: '/toolkit/cyberChef/Hash-SHA-512.256',
      },
      {
        name: 'SHA-512/224 \u8ba1\u7b97',
        url: '/toolkit/cyberChef/Hash-SHA-512.224',
      },
      {
        name: 'SHA-512 \u8ba1\u7b97',
        url: '/toolkit/cyberChef/Hash-SHA-512',
      },
      {
        name: 'SHA-384 \u8ba1\u7b97',
        url: '/toolkit/cyberChef/Hash-SHA-384',
      },
      {
        name: 'SHA-256 \u8ba1\u7b97',
        url: '/toolkit/cyberChef/Hash-SHA-256',
      },
      {
        name: 'SHA-224 \u8ba1\u7b97',
        url: '/toolkit/cyberChef/Hash-SHA-224',
      },
      {
        name: 'SHA-3 \u8ba1\u7b97',
        url: '/toolkit/cyberChef/Hash-SHA-3',
      },
      {
        name: 'SHA-2 \u8ba1\u7b97',
        url: '/toolkit/cyberChef/Hash-SHA-2',
      },
      {
        name: 'SHA-1 \u8ba1\u7b97',
        url: '/toolkit/cyberChef/Hash-SHA-1',
      },
      {
        name: 'SHA-0 \u8ba1\u7b97',
        url: '/toolkit/cyberChef/Hash-SHA-0',
      },
      {
        name: 'MD6 \u8ba1\u7b97',
        url: '/toolkit/cyberChef/Hash-MD6',
      },
      {
        name: 'MD4 \u8ba1\u7b97',
        url: '/toolkit/cyberChef/Hash-MD4',
      },
      {
        name: 'MD2 \u8ba1\u7b97',
        url: '/toolkit/cyberChef/Hash-MD2',
      },
      {
        name: 'MD5 \u8ba1\u7b97',
        url: '/toolkit/cyberChef/Hash-MD5',
      },
    ],
  },
  {
    name: '\u7f16\u7801\u8f6c\u6362',
    tools: [
      {
        name: 'Unicode \u89e3\u7801',
        url: '/toolkit/cyberChef/UnicodeDecode',
      },
      {
        name: 'Unicode \u7f16\u7801',
        url: '/toolkit/cyberChef/UnicodeEncode',
      },
      {
        name: 'HTML \u89e3\u7801',
        url: '/toolkit/cyberChef/HTMLDecode',
      },
      {
        name: 'HTML \u7f16\u7801',
        url: '/toolkit/cyberChef/HTMLEncode',
      },
      {
        name: 'Charcode \u89e3\u7801',
        url: '/toolkit/cyberChef/FromCharcode',
      },
      {
        name: 'Charcode \u7f16\u7801',
        url: '/toolkit/cyberChef/ToCharcode',
      },
      {
        name: 'Hexdump \u89e3\u7801',
        url: '/toolkit/cyberChef/FromHexdump',
      },
      {
        name: 'Hexdump \u7f16\u7801',
        url: '/toolkit/cyberChef/ToHexdump',
      },
      {
        name: '\u6469\u65af\u5bc6\u7801\u89e3\u7801',
        url: '/toolkit/cyberChef/MorseDecode',
      },
      {
        name: '\u6469\u65af\u5bc6\u7801\u7f16\u7801',
        url: '/toolkit/cyberChef/MorseEncode',
      },
      {
        name: 'URL \u89e3\u7801',
        url: '/toolkit/cyberChef/URLDecoder',
      },
      {
        name: 'URL \u7f16\u7801',
        url: '/toolkit/cyberChef/URLEncoder',
      },
      {
        name: 'Hex \u89e3\u7801',
        url: '/toolkit/cyberChef/HexDecoder',
      },
      {
        name: 'Hex \u7f16\u7801',
        url: '/toolkit/cyberChef/HexEncoder',
      },
      {
        name: 'Base64 \u89e3\u7801',
        url: '/toolkit/cyberChef/Base64Decoder',
      },
      {
        name: 'Base64 \u7f16\u7801',
        url: '/toolkit/cyberChef/Base64Encoder',
      },
    ],
  },
  {
    name: '\u4e8c\u8fdb\u5236\u5904\u7406',
    tools: [
      {
        name: '\u6587\u4ef6\u683c\u5f0f\u8bc6\u522b',
        url: '/tools/file',
      },
      {
        name: 'Pyc \u8f6c Asm',
        url: '/tools/pyc2asm',
      },
      {
        name: 'Pyc \u8f6c Py',
        url: '/tools/pyc2py',
      },
      {
        name: 'Hex \u7f16\u8f91\u5668',
        url: '/tools/hexeditor',
      },
    ],
  },

  {
    name: '\u683c\u5f0f\u8f6c\u6362',
    tools: [
      {
        name: 'LESS CSS \u4e92\u8f6c',
        url: '/tools/less2css',
      },
      {
        name: 'markdown html \u4e92\u8f6c',
        url: '/tools/md2html',
      },
      {
        name: 'JSON XML \u4e92\u8f6c',
        url: '/tools/json2xml',
      },
      {
        name: 'JSON \u8f6c yaml',
        url: '/tools/json2yaml',
      },
      {
        name: 'JSON \u8f6c GO',
        url: '/tools/json2go',
      },
      {
        name: 'JSON \u8f6c CSV/EXCEL',
        url: '/tools/jsontocsv',
      },
      {
        name: 'JSON JavaScript \u4e92\u8f6c',
        url: '/tools/json2js',
      },
    ],
  },
  {
    name: '\u6570\u636e\u53ef\u89c6\u5316',
    tools: [
      {
        name: '\u751f\u6210\u5357\u4e01\u683c\u5c14\u73ab\u7470\u56fe',
        url: '/tools/chart_nightingale',
      },
      {
        name: '\u751f\u6210\u6298\u7ebf\u56fe',
        url: '/tools/chart_line',
      },
      {
        name: '\u751f\u6210\u96f7\u8fbe\u56fe',
        url: '/tools/chart_radar',
      },
    ],
  },
  {
    name: '\u6587\u5b57\u5904\u7406',
    tools: [
      {
        name: '\u79fb\u9664\u7a7a\u767d\u5b57\u7b26',
        url: '/toolkit/cyberChef/RemoveWhitespace',
      },
      {
        name: '\u6587\u5b57\u8f6c\u9a7c\u5cf0/\u4e0b\u5212\u7ebf\u683c\u5f0f',
        url: '/tools/camelcase',
      },
      {
        name: '\u4e2d\u82f1\u6587\u52a0\u7a7a\u683c',
        url: '/tools/cn_space_en',
      },
      {
        name: '\u751f\u6210\u4e71\u5e8f\u6587\u5b57',
        url: '/tools/shuffle_text_generator',
      },
      {
        name: '\u6587\u5b57\u6dfb\u52a0\u884c\u53f7',
        url: '/tools/line_number',
      },
      {
        name: '\u751f\u6210 Figlet \u7ec8\u7aef\u827a\u672f\u5b57',
        url: '/tools/figlet',
      },
      {
        name: '\u751f\u6210 Leet \u9ed1\u5ba2\u6587\u5b57',
        url: '/tools/leet_convert',
      },
      {
        name: '\u6587\u672c\u5dee\u5f02\u5bf9\u6bd4',
        url: '/tools/diff',
      },
      {
        name: '\u5927\u5c0f\u5199\u8f6c\u6362',
        url: '/tools/case_convert',
      },
      {
        name: '\u5b57\u6570\u7edf\u8ba1',
        url: '/tools/word_count',
      },
    ],
  },
  {
    name: '\u6280\u672f\u901f\u67e5\u8868',
    tools: [
      {
        name: 'Git \u547d\u4ee4\u901f\u67e5',
        url: '/tools/git',
      },
      {
        name: 'ASCII \u7801\u8868',
        url: '/tools/ascii',
      },
    ],
  },
  {
    name: '\u97f3\u9891\u89c6\u9891\u5904\u7406',
    tools: [
      {
        name: '\u89c6\u9891\u62c6\u5206\u6210\u56fe\u7247\u5e27',
        url: '/tools/videoframe',
      },
      {
        name: '\u89c6\u9891\u8f6c gif \u52a8\u56fe',
        url: '/tools/video2gif',
      },
      {
        name: '\u89c6\u9891\u63d0\u53d6\u97f3\u9891',
        url: '/tools/getvideoaudio',
      },
      {
        name: '\u89c6\u9891\u683c\u5f0f\u8f6c\u6362',
        url: '/tools/videofmt',
      },
      {
        name: '\u97f3\u9891\u683c\u5f0f\u8f6c\u6362',
        url: '/tools/audiofmt',
      },
    ],
  },
  {
    name: '\u56fe\u7247\u5904\u7406',
    tools: [
      {
        name: '\u56fe\u7247\u8f6c Base64',
        url: '/tools/img2base64',
      },
      {
        name: '\u751f\u6210\u4e5d\u5bab\u683c\u56fe\u7247',
        url: '/tools/img_split',
      },
      {
        name: 'OCR \u56fe\u7247\u6587\u5b57\u8bc6\u522b',
        url: '/tools/ocr',
      },
      {
        name: '\u56fe\u7247\u5706\u89d2',
        url: '/tools/img_radius',
      },
      {
        name: '\u56fe\u7247\u50cf\u7d20\u5316',
        url: '/tools/pixel_img',
      },
      {
        name: '\u56fe\u7247\u9ed1\u767d\u5316',
        url: '/tools/uncolor',
      },
      {
        name: '\u56fe\u7247\u538b\u7f29',
        url: '/tools/img_sharp',
      },
      {
        name: '\u56fe\u7247\u6dfb\u52a0\u6c34\u5370',
        url: '/tools/watermark',
      },
      {
        name: '\u56fe\u7247\u683c\u5f0f\u8f6c\u6362',
        url: '/tools/img_conversion',
      },
    ],
  },
  {
    name: '\u5b89\u5168\u5de5\u5177',
    tools: [
      {
        name: 'MD5 \u54c8\u5e0c\u78b0\u649e',
        url: '/tools/md5fastcollision',
      },
      {
        name: 'ZIP \u5bc6\u7801\u7834\u89e3',
        url: '/tools/zipcrack',
      },
      {
        name: 'XSS \u5411\u91cf\u751f\u6210',
        url: '/tools/xssvector',
      },
      {
        name: 'WebShell \u68c0\u6d4b',
        url: '/webShell',
      },
    ],
  },
  {
    name: '\u4ee3\u7801\u683c\u5f0f\u5316',
    tools: [
      {
        name: 'SQL \u4ee3\u7801\u683c\u5f0f\u5316',
        url: '/toolkit/format/sql',
      },
      {
        name: 'Java \u4ee3\u7801\u683c\u5f0f\u5316',
        url: '/toolkit/format/java',
      },
      {
        name: 'CSS \u4ee3\u7801\u683c\u5f0f\u5316',
        url: '/toolkit/format/css',
      },
      {
        name: 'JavaScript \u4ee3\u7801\u683c\u5f0f\u5316',
        url: '/toolkit/format/javascript',
      },
      {
        name: 'JSON \u4ee3\u7801\u683c\u5f0f\u5316',
        url: '/toolkit/format/json',
      },
      {
        name: 'YAML \u4ee3\u7801\u683c\u5f0f\u5316',
        url: '/toolkit/format/yaml',
      },
      {
        name: 'XML \u4ee3\u7801\u683c\u5f0f\u5316',
        url: '/toolkit/format/xml',
      },
      {
        name: 'HTML \u4ee3\u7801\u683c\u5f0f\u5316',
        url: '/toolkit/format/html',
      },
    ],
  },
  {
    name: '\u52a0\u5bc6\u89e3\u5bc6',
    tools: [
      {
        name: 'LS47 \u89e3\u5bc6',
        url: '/toolkit/cyberChef/LS47Decrypt',
      },
      {
        name: 'LS47 \u52a0\u5bc6',
        url: '/toolkit/cyberChef/LS47Encrypt',
      },
      {
        name: 'GOST \u5bc6\u7801\u89e3\u5bc6',
        url: '/toolkit/cyberChef/GOSTDecrypt',
      },
      {
        name: 'GOST \u5bc6\u7801\u52a0\u5bc6',
        url: '/toolkit/cyberChef/GOSTEncrypt',
      },
      {
        name: '\u57c3\u7279\u5df4\u4ec0\u5bc6\u7801',
        url: '/toolkit/cyberChef/AtbashCipher',
      },
      {
        name: '\u4eff\u5c04\u5bc6\u7801\u89e3\u5bc6',
        url: '/toolkit/cyberChef/AffineDecode',
      },
      {
        name: '\u4eff\u5c04\u5bc6\u7801\u52a0\u5bc6',
        url: '/toolkit/cyberChef/AffineEncode',
      },
      {
        name: 'Bifid \u5bc6\u7801\u89e3\u5bc6',
        url: '/toolkit/cyberChef/BifidDecode',
      },
      {
        name: 'Bifid \u5bc6\u7801\u52a0\u5bc6',
        url: '/toolkit/cyberChef/BifidEncode',
      },
      {
        name: '\u57f9\u6839\u5bc6\u7801\u89e3\u5bc6',
        url: '/toolkit/cyberChef/BaconDecode',
      },
      {
        name: '\u57f9\u6839\u5bc6\u7801\u52a0\u5bc6',
        url: '/toolkit/cyberChef/BaconEncode',
      },
      {
        name: '\u6805\u680f\u5bc6\u7801\u89e3\u5bc6',
        url: '/toolkit/cyberChef/RailFenceDecode',
      },
      {
        name: '\u6805\u680f\u5bc6\u7801\u52a0\u5bc6',
        url: '/toolkit/cyberChef/RailFenceEncode',
      },
      {
        name: '\u7ef4\u5409\u5c3c\u4e9a\u5bc6\u7801\u89e3\u5bc6',
        url: '/toolkit/cyberChef/VigenereDecode',
      },
      {
        name: '\u7ef4\u5409\u5c3c\u4e9a\u5bc6\u7801\u52a0\u5bc6',
        url: '/toolkit/cyberChef/VigenereEncode',
      },
      {
        name: 'Fernet \u89e3\u5bc6',
        url: '/toolkit/cyberChef/FernetDecrypt',
      },
      {
        name: 'Fernet \u52a0\u5bc6',
        url: '/toolkit/cyberChef/FernetEncrypt',
      },
      {
        name: 'Blowfish \u89e3\u5bc6',
        url: '/toolkit/cyberChef/BlowfishDecrypt',
      },
      {
        name: 'Blowfish \u52a0\u5bc6',
        url: '/toolkit/cyberChef/BlowfishEncrypt',
      },
      {
        name: 'RSA \u89e3\u5bc6',
        url: '/toolkit/cyberChef/RSADecrypt',
      },
      {
        name: 'RSA \u52a0\u5bc6',
        url: '/toolkit/cyberChef/RSAEncrypt',
      },
      {
        name: 'SM4 \u89e3\u5bc6',
        url: '/toolkit/cyberChef/SM4Decrypt',
      },
      {
        name: 'SM4 \u52a0\u5bc6',
        url: '/toolkit/cyberChef/SM4Encrypt',
      },
      {
        name: 'Rabbit \u52a0\u89e3\u5bc6',
        url: '/toolkit/cyberChef/Rabbit',
      },
      {
        name: 'RC4 Drop \u52a0\u89e3\u5bc6',
        url: '/toolkit/cyberChef/RC4Drop',
      },
      {
        name: 'RC4 \u52a0\u89e3\u5bc6',
        url: '/toolkit/cyberChef/RC4',
      },
      {
        name: 'RC2 \u89e3\u5bc6',
        url: '/toolkit/cyberChef/RC2Decrypt',
      },
      {
        name: 'RC2 \u52a0\u5bc6',
        url: '/toolkit/cyberChef/RC2Encrypt',
      },
      {
        name: '3DES \u89e3\u5bc6',
        url: '/toolkit/cyberChef/3DESDecrypt',
      },
      {
        name: '3DES \u52a0\u5bc6',
        url: '/toolkit/cyberChef/3DESEncrypt',
      },
      {
        name: 'DES \u89e3\u5bc6',
        url: '/toolkit/cyberChef/DESDecrypt',
      },
      {
        name: 'DES \u52a0\u5bc6',
        url: '/toolkit/cyberChef/DESEncrypt',
      },
      {
        name: 'AES \u89e3\u5bc6',
        url: '/toolkit/cyberChef/AESDecrypt',
      },
      {
        name: 'AES \u52a0\u5bc6',
        url: '/toolkit/cyberChef/AESEncrypt',
      },
    ],
  },
  {
    name: '\u5176\u4ed6',
    tools: [
      {
        name: '\u4eba\u751f\u683c\u5b50',
        url: '/tools/lifecount',
      },
      {
        name: '\u5012\u8ba1\u65f6',
        url: '/tools/countdown',
      },
      {
        name: '\u65e9\u4e2d\u665a\u5403\u5565\u5462',
        url: '/tools/eatwhat',
      },
      {
        name: '\u624b\u7ed8\u767d\u677f',
        url: '/tools/excalidraw',
      },
      {
        name: '\u989c\u8272\u683c\u5f0f\u8f6c\u6362',
        url: '/tools/color_convert',
      },
      {
        name: '\u989c\u8272\u5438\u53d6\u5668',
        url: '/tools/color_picker',
      },
      {
        name: '\u4e8c\u7ef4\u7801\u751f\u6210\u5668',
        url: '/tools/generate_qrcode',
      },
      {
        name: '\u4e8c\u7ef4\u7801\u89e3\u6790\u5668',
        url: '/tools/de_qrcode',
      },
      {
        name: '\u968f\u673a\u90ae\u7bb1\u751f\u6210',
        url: '/tools/random_email',
      },
      {
        name: '\u968f\u673a USER-AGENT \u751f\u6210\u5668',
        url: '/tools/random_ua',
      },
      {
        name: '\u968f\u673a UUID \u751f\u6210\u5668',
        url: '/tools/uuid_gen',
      },
      {
        name: '\u968f\u673a IP \u751f\u6210\u5668',
        url: '/tools/random_ip',
      },
      {
        name: '\u968f\u673a\u6570/\u5bc6\u7801\u751f\u6210\u5668',
        url: '/tools/random',
      },
      {
        name: '\u516b\u8fdb\u5236\u8f6c\u5b57\u7b26\u4e32',
        url: '/toolkit/cyberChef/FromOctal',
      },
      {
        name: '\u5b57\u7b26\u4e32\u8f6c\u516b\u8fdb\u5236',
        url: '/toolkit/cyberChef/ToOctal',
      },
      {
        name: '\u4e8c\u8fdb\u5236\u8f6c\u5b57\u7b26\u4e32',
        url: '/toolkit/cyberChef/FromBinary',
      },
      {
        name: '\u5b57\u7b26\u4e32\u8f6c\u4e8c\u8fdb\u5236',
        url: '/toolkit/cyberChef/ToBinary',
      },
      {
        name: '\u6d6e\u70b9\u6570\u8f6c\u5b57\u7b26\u4e32',
        url: '/toolkit/cyberChef/FromFloat',
      },
      {
        name: '\u5b57\u7b26\u4e32\u8f6c\u6d6e\u70b9\u6570',
        url: '/toolkit/cyberChef/ToFloat',
      },
      {
        name: '\u5341\u8fdb\u5236\u8f6c\u5b57\u7b26\u4e32',
        url: '/toolkit/cyberChef/FromDecimal',
      },
      {
        name: '\u5b57\u7b26\u4e32\u8f6c\u5341\u8fdb\u5236',
        url: '/toolkit/cyberChef/ToDecimal',
      },
      {
        name: '\u5341\u516d\u8fdb\u5236\u8f6c PEM',
        url: '/toolkit/cyberChef/HexToPEM',
      },
      {
        name: 'PEM \u8f6c\u5341\u516d\u8fdb\u5236',
        url: '/toolkit/cyberChef/PEMToHex',
      },
      {
        name: 'GOST \u7b7e\u540d',
        url: '/toolkit/cyberChef/GOSTSign',
      },
      {
        name: '\u751f\u6210 RSA \u5bc6\u94a5',
        url: '/toolkit/cyberChef/RSAKeyPair',
      },
      {
        name: '\u6587\u4ef6\u5939\u76ee\u5f55\u6811\u751f\u6210',
        url: '/tools/dir_tree',
      },
      {
        name: 'CSS \u538b\u7f29',
        url: '/tools/css_minifier',
      },
      {
        name: 'Docker run \u547d\u4ee4\u8f6c Docker compose',
        url: '/tools/docker_run_to_docker_compose',
      },
      {
        name: 'CIDR \u8ba1\u7b97',
        url: '/tools/cidr',
      },
      {
        name: '\u8fdb\u5236\u8f6c\u6362',
        url: '/tools/radix_convert',
      },
      {
        name: 'Unix \u65f6\u95f4\u6233\u8f6c\u6362',
        url: '/tools/unix',
      },
      {
        name: '\u4ee3\u7801\u622a\u56fe',
        url: '/toolkit/codeshot',
      },
    ],
  },
]

export const SECURITY_HOLE = [
  {
    name: '\u6f0f\u6d1e\u60c5\u62a5',
    url: '/vuldb',
  },
  {
    name: 'IP \u60c5\u62a5',
    url: '/ip-intelligence',
  },
]
